import { DOCUMENT_VIEWER_HEADER_FIELD_TEST_ID } from '@ctw/shared/test/ids';
import { tw, twx } from '@ctw/shared/utils/tailwind';
import { orderBy } from 'lodash-es';

export interface DocumentViewerHeaderField {
  label: string;
  value: string;
}

export interface DocumentViewerHeaderFieldsProps {
  fields: Array<DocumentViewerHeaderField>;
}

export const DocumentViewerHeaderFields = ({ fields }: DocumentViewerHeaderFieldsProps) => (
  <dl
    data-testid={DOCUMENT_VIEWER_HEADER_FIELD_TEST_ID}
    className={twx('flex min-h-14 w-full justify-between gap-4')}
  >
    {orderBy(fields, 'rank').map((field) => (
      <div key={field.label} className={tw`my-auto block flex-1 space-y-2`}>
        <dt
          className={tw`block whitespace-nowrap font-medium text-white/80 text-xs uppercase leading-none tracking-wide`}
        >
          {field.label}
        </dt>
        <dd
          className={tw`!overflow-hidden line-clamp-3 text-ellipsis font-normal text-sm text-white leading-none`}
        >
          {field.value}
        </dd>
      </div>
    ))}
  </dl>
);
